// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2VoIP","container":"styles_container__LNIc6","title":"styles_title__3YMVJ","wrapper":"styles_wrapper__1gt3o","answer":"styles_answer__2P3eC"};